export const COMPONENT_NAME = "admin-content";
